module.exports = __webpack_public_path__ + "img/davidsfondslogo.9e07576b.png";